import { createListenerMiddleware } from '@reduxjs/toolkit'
import { addFullListingsStateListeners } from '@mfs/client/listings-client/reducers/listings'

export const listenerMiddleware = createListenerMiddleware()
addFullListingsStateListeners(listenerMiddleware.startListening)
